import { LicenseInfo } from '@mui/x-data-grid-pro'
import { useEffect } from 'react'

export function useInstanceLicenses() {
  useEffect(() => {
    if (process.env.PUBLIC_MATERIAL_UI_X_LICENSE) {
      LicenseInfo.setLicenseKey(process.env.PUBLIC_MATERIAL_UI_X_LICENSE)
    }
  }, [])
}
